module.exports = __webpack_public_path__ + "img/R06_S2.d5e21ceb.svg";